import React, { useEffect } from "react"

function InArticleAd() {

    useEffect(() => {
        const loadAds = () => {
            if (window.adsbygoogle) {
                window.adsbygoogle.push({});
            }
        };

        loadAds();
    }, []);

    return (
        <div className="m-2">
            <ins className="adsbygoogle"
                style={{ display: "block", textAlign:"center" }}
                data-ad-layout="in-article"
                data-ad-format="fluid"
                data-ad-client="ca-pub-2564277604931209"
                data-ad-slot="4907955822"></ins>
            <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2564277604931209"
                crossorigin="anonymous"></script>
        </div>
    );
}
export default InArticleAd;